<template>
  <div class="group/divider relative py-2">
    <DividerArt :kind="attrs.style" />
    <div v-if="!readOnly" class="absolute right-0 top-1/2 flex -translate-y-1/2 gap-1 rounded-lg bg-white p-0.5 opacity-0 shadow ring-1 ring-[#1c4848]/10 transition-opacity focus-within:opacity-100 group-hover/divider:opacity-100">
      <button v-for="option in OPTIONS" :key="option.value" type="button" class="rounded-md px-2 py-1 text-[11px] font-bold" :class="attrs.style === option.value ? 'bg-[#1c4848] text-white' : 'text-[#1c4848]/60 hover:bg-[#1c4848]/5'" @click="set({ style: option.value })">{{ option.label }}</button>
    </div>
  </div>
</template>

<script setup>
import DividerArt from '@/components/writer/reader/DividerArt.vue';

const OPTIONS = [{ value: 'ornament', label: 'Ornament' }, { value: 'line', label: 'Line' }, { value: 'space', label: 'Space' }];

defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
</script>
